import { Outlet, createRootRoute } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../lib/queryClient";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { UpdateBanner } from "../components/layout/UpdateBanner";

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  // At the root so every route gets its own <title>, login and the public
  // survey included.
  useDocumentTitle();

  return (
    <QueryClientProvider client={queryClient}>
      <Outlet />
      {/* At the root so it reaches every screen, the login page included — a
          tab left open overnight is exactly the one running old code. */}
      <UpdateBanner />
    </QueryClientProvider>
  );
}
